<!-- 底部文件预览组件 -->
<template>
  <span>
    <span>
      <a href="javascript:;" @click="goFileView(2)" :class="[readArray.indexOf(2) > -1 ? 'readed_' : 'unread']">《保险条款及责任免除》</a>
      <a href="javascript:;" @click="goFileView(5)" :class="[readArray.indexOf(5) > -1 ? 'readed_' : 'unread']">《投保须知》</a>
      <a href="javascript:;" @click="goFileView(10)" :class="[readArray.indexOf(10) > -1 ? 'readed_' : 'unread']">《特别约定》</a>
    </span>
    <!-- 文件展示弹框 -->
    <a-modal :width="1000" height="400px" class="pdfstyle myClause_cps" id="myClause_cps" forceRender title="预览" v-model="fileViewShow" @cancel="closeBtn">
      <div id="pdf">
        <div v-if="file1 == 2">
          <div id="pafdemo1_cps" v-html="url"></div>
        </div>
        <div v-if="file1 == 0">
          <div id="pafdemo1_cps"></div>
        </div>
      </div>
      <template slot="footer">
        <a-button class="mrg_r22_" @click="pushToRead" :disabled="readDisabled" type="primary"> {{ readDisabled ? '请下滑看完本内容再同意' : '我已阅读' }}</a-button>
      </template>
    </a-modal>
    <span v-show="isAllReadShow">{{ isAllRead }}</span>
  </span>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》'
import Pdfh5 from 'pdfh5';
export default {
  //import引入的组件需要注入到对象中才能使用
  // components: { pdf },
  data() {
    //这里存放数据
    return {
      file1: 2, //文件类型
      isAllReadShow: false, //是否全部阅读
      itemIndex: '', //当前的文件下标
      url: '', //文件地址
      fileViewShow: false,
      fileContent: null,
      readArray: [],
      readDisabled: true,
    };
  },
  props: {
    plancode: {
      type: String,
    },
  },
  //监听属性 类似于data概念
  computed: {
    agreementData() {
      //产品文件数据
      return this.$store.state.insureDoc.agreementData;
    },
    isAllRead() {
      //判断是否全部阅读
      if ((this.$route.query.p != '5IE2250002' && this.readArray.length == 3) || (this.$route.query.p == '5IE2250002' && this.readArray.length == 4)) {
        //三次阅读
        this.$store.commit('setagreementAllRead', true);
      } else {
        this.$store.commit('setagreementAllRead', false);
      }
      return true;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //文件阅读 打开文件展示弹框
    goFileView(num) {
      let index = 0;
      if (this.plancode == 'BOCI192' || this.plancode == 'BOCI195') {
        index = 0;
      }
      if (this.plancode == 'BOCI193' || this.plancode == 'BOCI196') {
        index = 1;
      }
      if (this.plancode == 'BOCI194' || this.plancode == 'BOCI197') {
        index = 2;
      }
      this.itemIndex = num;
      let materialDtoList = this.agreementData.materialDtoList;
      let file = materialDtoList.filter(item => item.materialType == num);
      if (file && file.length) {
        this.fileViewShow = true;
        this.fileContent = file[index];
        this.readDisabled = true;
        this.file1 = this.fileContent.materialForm;
        document.getElementById('pafdemo1_cps').innerHTML = ''; //清空容器
        this.$nextTick(() => {
          //重制滚动状态
          if (this.file1 == 0) {
            new Pdfh5('#pafdemo1_cps', {
              pdfurl: this.fileContent.materialContent,
            });
          } else {
            this.url = this.fileContent.materialContent;
          }
          this.$nextTick(() => {
            //生成阅读器
            let pdf = document.getElementById('myClause_cps').querySelector('.ant-modal-body');
            pdf.scrollTop = 0;
            this.bodyScroll();
            pdf.addEventListener('scroll', this.bodyScroll);
          });
        });
      } else {
        if (this.readArray.indexOf(this.itemIndex) == -1) {
          //如果未配置文件 当已阅读处理
          this.readArray.push(this.itemIndex);
        }
        this.$message.warning('本产品未配置该文件!');
      }
    },
    async bodyScroll() {
      //监听阅读器滚动状态
      let pdf = document.getElementById('myClause_cps').querySelector('.ant-modal-body');
      let padview = document.getElementById('pafdemo1_cps').querySelector('.pdfViewer') || document.getElementById('pafdemo1_cps');
      let scrollTop = pdf.scrollTop; //滚动距离
      let modalHeight = pdf.clientHeight; // 弹窗高度
      let clientHeight = padview.clientHeight; //大小
      if (clientHeight > 0 && scrollTop > 0 && scrollTop + 1200 >= clientHeight) {
        //滚动距离 + 窗口大小 == 容器大小 即触底
        this.readDisabled = false;
      }
      if (clientHeight < modalHeight - 48 && clientHeight != 0) {
        this.readDisabled = false;
      }
      if(clientHeight == 0){ //初始化时 容器为空
        this.readDisabled = false;
      }
    },
    pushToRead() {
      // 确定阅读文件 保存状态
      this.fileViewShow = false;
      if (this.readArray.indexOf(this.itemIndex) == -1) {
        this.readArray.push(this.itemIndex);
      }
    },
    closeBtn() {
      this.url = '';
      this.fileViewShow = false;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.pdfstyle >>> .ant-modal-body {
  height: 70vh;
  overflow-y: auto;
}

.myClause_cps .ant-modal-footer {
  text-align: center !important;
}

.unread {
  color: red;
}

.viewerContainer {
  overflow: visible !important;
}
</style>
